/**
 * Normalizes bullet content from multiple legacy formats to a single shape:
 * { title?: string | null, text?: string, items?: string[] | null }
 *
 * Supports:
 * - Object with items array: { title, items: string[] }
 * - Object with text: { title, text }
 * - String with " – " separator: "Title – Text"
 * - Plain string
 */
export function normalizeBullet(bullet) {
  if (bullet && typeof bullet === 'object') {
    const title = bullet.title && String(bullet.title).trim() ? bullet.title.trim() : null;
    if (Array.isArray(bullet.items) && bullet.items.length > 0) {
      return {
        title,
        items: bullet.items.map((s) => String(s).trim()).filter(Boolean)
      };
    }
    if ('text' in bullet) {
      const text = (bullet.text != null ? String(bullet.text) : '').trim();
      return { title, text, items: null };
    }
  }
  const str = String(bullet ?? '');
  const sep = ' – ';
  const i = str.indexOf(sep);
  if (i === -1) return { title: null, text: str.trim(), items: null };
  return {
    title: str.slice(0, i).trim(),
    text: str.slice(i + sep.length).trim(),
    items: null
  };
}
